// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const keycloakBaseUrl = window.location.origin;

export const environment = {
  baseUrl: window.location.origin,
  userSessionValidityMs: '840000',
  tendersHubUrl: 'api/hub/tendersHub',
  certificatesHubUrl: 'api/hub/certificatesHub',
  useHttps: true,
  production: false,
  stage: true,
  keycloakClient: 'webapp',
  keycloakClientSecret: '7ace2a2a-a2f3-40e2-90d1-e2d8bdab3211',
  keycloakRealmUrl: keycloakBaseUrl + '/realms/carrierportal',
  systemSettingServiceUrl: '/api/systemSettings',
  orderServiceUrl: '/api/order',
  costTypeServiceUrl: '/api/costType',
  currencyServiceUrl: '/api/currency',
  carrierServiceUrl: '/api/carrier',
  areaServiceUrl: '/api/area',
  selfbillingServiceUrl: '/api/selfbilling',
  freightExchangeServiceUrl: '/api/freightexchange',
  tenderServiceUrl: '/api/tender',
  actionReportCauseServiceUrl: '/api/actionReportCause',
  incidentReportingServiceUrl: '/api/incidentReporting',
  orderConfirmationServiceUrl: '/api/orderConfirmation',
  anonymousServiceUrl: '/api/anonymous',
  userServiceUrl: '/api/user',
  businessUnitServiceUrl: '/api/businessUnit',
  businessUnitSettingsServiceUrl: '/api/businessUnitSettings',
  businessunits: [
    {
      url: 'testcp.hs-logisticservices.com',
      css: 'styles/bu-hs.css',
      bu: 'hs',
      theme: 'ls-theme',
      icon: './assets/template/hs-favicon.png',
      logo: './assets/template/H&SLogisticsLogo_RGB.PNG',
      website: 'www.denhartogh.com',
      termsAndCondition: undefined,
      supportEmail: 'helpdesk@hs-group.eu',
    },
    {
      url: 'testcp.dh-logisticservices.com',
      css: 'styles/bu-dh.css',
      bu: 'dh',
      theme: 'dh-theme',
      icon: './assets/template/dh-favicon.png',
      logo: './assets/template/DHLogisticsLogo_RGB.PNG',
      website: 'www.denhartogh.com',
      termsAndCondition: undefined,
      supportEmail: 'helpdesk@hs-group.eu',
    },
    {
      url: 'testcp.whs-logistics.com',
      css: 'styles/bu-whs.css',
      bu: 'whs',
      theme: 'whs-theme',
      icon: './assets/template/whs-favicon.ico',
      logo: './assets/template/whs.png',
      website: 'www.denhartogh.com',
      termsAndCondition: undefined,
      supportEmail: 'helpdesk@hs-group.eu',
    },
    {
      url: 'testcp.horizonlogisticssolutions.com',
      css: 'styles/bu-horizon.css',
      bu: 'horizon',
      theme: 'horizon-theme',
      icon: '../assets/template/horizon-favicon.png',
      logo: '../assets/template/horizon-logo.png',
      website: 'www.horizonlogisticssolutions.com',
      termsAndCondition: undefined,
      supportEmail: 'info@horizon4pl.com',
    },
  ],
  orderDocumentServiceUrl: '/api/orderDocument',
  fileServiceUrl: '/api/file',
  exWorkOrderServiceUrl: '/api/exWorkOrder',
  instructionDocsUrl: '/api/instructionDocs',
  helpDocsUrl: '/api/helpDocs',
  customerServiceUrl: '/api/customer',
  healthCheckUrl: '/api/healthCheck',
  version: {
    "dirty": false,
    "raw": "8893834",
    "hash": "8893834",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "8893834",
    "semverString": null,
    "version": "3.0.9"
}};
